// The creator invitation link (the creator-signup page with the email
// pre-filled), built from the panel the admin is using right now — so on
// localhost it points at localhost, on staging at staging, and so on. The
// backend's invite email builds the same link from PANEL_URL.
export const creatorInviteUrl = (email) =>
  `${window.location.origin}${window.location.pathname}#/creator-signup?email=${encodeURIComponent(email)}`;
